export enum DateTypeSaleStatement {
  TransactionDate = 'transactionDate',
  DeliveryDate = 'deliveryDate',
  CommercialDate = 'commercialDate',
  AuctionDate = 'auctionDate',
}

export const DateTypeSaleStatementLabel: Record<DateTypeSaleStatement, string> = {
  [DateTypeSaleStatement.TransactionDate]: 'Data do Pedido',
  [DateTypeSaleStatement.DeliveryDate]: 'Data de Entrega',
  [DateTypeSaleStatement.CommercialDate]: 'Data Comercial',
  [DateTypeSaleStatement.AuctionDate]: 'Data do Leilão',
};
